export default "__VITE_ASSET__GoVh3fPl__"